"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "portfolioKey": "prt_9431687b9b2044aea20463de3980260e",
    "name": "Bullseye Test Portfolio 1",
    "clientAccountKey": "ca_e57f2ba6d7f24aa1800dd40ac3565cf2",
    "clientAccountName": "Bullseye Test1",
    "serviceType": "StatementOfAdvice",
    "currentValue": 2863715.34,
    "incomeReturnValue": 0.000000,
    "incomeReturnPercentage": 0.0,
    "capitalReturnValue": -222702.660000,
    "capitalReturnPercentage": -0.065364,
    "totalReturnValue": -222702.660000,
    "totalReturnPercentage": -0.065364,
    "inceptionDate": "2020-12-31T00:00:00",
    "benchmarks": [
        {
            "benchmarkKey": "bm_c13f1e67001b4d14bdbcd485c5006360",
            "code": "XTL",
            "name": "S&P/ASX 20 Index"
        },
        {
            "benchmarkKey": "bm_e43110562e9b49a2977ea5c223bad46d",
            "code": "XTO",
            "name": "S&P/ASX 100 Index"
        },
        {
            "benchmarkKey": "bm_7cad00dc25744477949f064181c76d0e",
            "code": "XJO",
            "name": "S&P/ASX 200 Index"
        },
        {
            "benchmarkKey": "bm_6e6e1eb08ecf4a08812b54aaf5a2a446",
            "code": "XKO",
            "name": "S&P/ASX 300 Index"
        },
        {
            "benchmarkKey": "bm_c8d176ce31c5458c96d2968f898001f6",
            "code": "XSO",
            "name": "S&P/ASX Small Ordinaries Index"
        },
        {
            "benchmarkKey": "bm_df669c2cafd24c17a2526c56e990ff1f",
            "code": "XPJ",
            "name": "S&P/ASX 200 A-REIT Index"
        },
        {
            "benchmarkKey": "bm_61c0eb1d16aa4985bbc91165c5120a12",
            "code": "SPBDABBT",
            "name": "S&P/ASX Bank Bill Index"
        },
        {
            "benchmarkKey": "bm_079a3fd51b55467ebd42d116c6a8aa04",
            "code": "SPBDASXT",
            "name": "S&P/ASX Australian Fixed Interest Index"
        },
        {
            "benchmarkKey": "bm_cf11291f887045f5b649584bd70671e2",
            "code": "SPX",
            "name": "S&P 500"
        },
        {
            "benchmarkKey": "bm_890a9dff9b754314b6e69057ca496a87",
            "code": "SGL",
            "name": "S&P Global 1200"
        },
        {
            "benchmarkKey": "bm_c56bd28c4b9a4b4c9bfeebe57e5b0702",
            "code": "BALINDX",
            "name": "The S&P/ASX Blended Equity and Bond - Balanced Index"
        },
        {
            "benchmarkKey": "bm_cf9f9a19583b49529350adb4f597fe54",
            "code": "CONSERVINDX",
            "name": "S&P/ASX Blended Equity and Bond - Conservative Index"
        },
        {
            "benchmarkKey": "bm_93f55454d8f446c7a3aaca33324039f3",
            "code": "GROWTHINDX",
            "name": "S&P/ASX Blended Equity and Bond - Growth Index"
        },
        {
            "benchmarkKey": "bm_5f27b5e839f643a09a5a1a745c5a91c9",
            "code": "HIGHGINDX",
            "name": "S&P/ASX Blended Equity and Bond - High Growth Index"
        },
        {
            "benchmarkKey": "bm_5dcf26bd80e9415d978467cd331cdd8d",
            "code": "SBR",
            "name": "S&P BRIC 40"
        },
        {
            "benchmarkKey": "bm_dd81ba83996a4d41934853236336240a",
            "code": "KRW",
            "name": "S&P/KRX ASIA 100"
        },
        {
            "benchmarkKey": "bm_17642ae88ba54d9a8ccf8817d3676ab2",
            "code": "SPJ500",
            "name": "S&P JAPAN 500 (JPY)"
        },
        {
            "benchmarkKey": "bm_e4887d1bdfac421fbc2f47bdd80a7a7c",
            "code": "SCRTAP",
            "name": "S&P ASIA PACIFIC BMI"
        },
        {
            "benchmarkKey": "bm_e724f18def8545068d7d8c4a3c413443",
            "code": "SPEURO",
            "name": "S&P Europe 350"
        },
        {
            "benchmarkKey": "bm_ee8601d1c7584f5097991eb79b7b8de9",
            "code": "GCPIAG",
            "name": "Consumer Price Index: All Groups"
        },
        {
            "benchmarkKey": "bm_e470033176884998a5e562616d5d2f12",
            "code": "SPAXIF",
            "name": "S&P/ASX INFRASTRUCTURE INDEX (AUD)"
        },
        {
            "benchmarkKey": "bm_e7c2720b1e7f4251a827b2fd6acff564",
            "code": "SPGTIND",
            "name": "S&P GLOBAL INFRASTRUCTURE INDEX"
        },
        {
            "benchmarkKey": "bm_1ed70c715c30452d9e29371c68248a4f",
            "code": "XNT",
            "name": "S&P/ASX 200 Net Total Return"
        },
        {
            "benchmarkKey": "bm_ab325685ba8342deb420f5a519504947",
            "code": "SGI",
            "name": "S&P Global 1200 Information Technology Index"
        },
        {
            "benchmarkKey": "bm_9fde65e868ef4e46bd58e7b6e654e8b1",
            "code": "NoBenchmark",
            "name": "No benchmark applicable"
        }
    ],
    "assetClasses": [
        {
            "assetClassKey": "ac_a3feff965110450db92d87bde98e12dc",
            "name": "",
            "value": 215744.54,
            "percentageOfPortfolio": 0.075337
        },
        {
            "assetClassKey": "ac_6531a08c235947679b810ce843b3ed29",
            "name": "Australian Cash",
            "value": 1108100.44,
            "percentageOfPortfolio": 0.386945
        },
        {
            "assetClassKey": "ac_f9b759f1c5f1462797aff3db83fbd584",
            "name": "Australian Fixed Income",
            "value": 353521.78,
            "percentageOfPortfolio": 0.123449
        },
        {
            "assetClassKey": "ac_110b35303e184b808b8342c8d0d288b9",
            "name": "Australian Shares",
            "value": 1186348.58,
            "percentageOfPortfolio": 0.414269
        }
    ],
    "recentTransactions": [
        {
            "transactionKey": "tran_a780f9e196cd4d4f98b8942c087991cb",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZ.ASX",
            "securityName": "Australia & New Zealand Banking Group Ltd.",
            "description": "Transfer In - 4219 x ANZ",
            "type": "TransferIn",
            "tradeDate": "2021-01-01T00:00:00",
            "units": 4219.000000,
            "price": 28.15000000,
            "transactionValue": 118764.85000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 118764.85
        },
        {
            "transactionKey": "tran_a4e7568f26a64496994f79feab387b73",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZ.ASX",
            "securityName": "Australia & New Zealand Banking Group Ltd.",
            "description": "Transfer In - 3403 x ANZ",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 3403.000000,
            "price": 28.15000000,
            "transactionValue": 95794.45000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 95794.45
        },
        {
            "transactionKey": "tran_d1b5ad4826f140f18e9c75d2f42e183c",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZPG.ASX",
            "securityName": "ANZ Capital Notes 4",
            "description": "Transfer In - 500 x ANZPG",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 500.000000,
            "price": 106.95000000,
            "transactionValue": 53475.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 53475.00
        },
        {
            "transactionKey": "tran_45460de5a92449ba8c9a2f2097ce12db",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZPG.ASX",
            "securityName": "ANZ Capital Notes 4",
            "description": "Transfer In - 1306 x ANZPG",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1306.000000,
            "price": 106.95000000,
            "transactionValue": 139676.70000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 139676.70
        },
        {
            "transactionKey": "tran_e0e7b93772d54c3090e4df36749fd64b",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZPG.ASX",
            "securityName": "ANZ Capital Notes 4",
            "description": "Transfer In - 1531 x ANZPG",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1531.000000,
            "price": 106.95000000,
            "transactionValue": 163740.45000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 163740.45
        },
        {
            "transactionKey": "tran_b4f7c9da31ce4c3d8c25fd51e094d384",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APL.ASX",
            "securityName": "Antipodes Global Investment Company Limited",
            "description": "Transfer In - 110667 x APL",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 110667.000000,
            "price": 1.12000000,
            "transactionValue": 123947.04000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 123947.04
        },
        {
            "transactionKey": "tran_2bb08708de3a4f7ab12ff10120846e35",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APL.ASX",
            "securityName": "Antipodes Global Investment Company Limited",
            "description": "Transfer In - 9998 x APL",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 9998.000000,
            "price": 1.12000000,
            "transactionValue": 11197.76000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 11197.76
        },
        {
            "transactionKey": "tran_334086f3456746e780ce1956ec03c214",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APL.ASX",
            "securityName": "Antipodes Global Investment Company Limited",
            "description": "Transfer In - 117131 x APL",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 117131.000000,
            "price": 1.12000000,
            "transactionValue": 131186.72000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 131186.72
        },
        {
            "transactionKey": "tran_86d0e4e0b9f34ce78f872205dd319470",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APT.ASX",
            "securityName": "Afterpay Limited",
            "description": "Transfer In - 85 x APT",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 85.000000,
            "price": 118.17000000,
            "transactionValue": 10044.45000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 10044.45
        },
        {
            "transactionKey": "tran_93152ca4563b49819b777e6ee0026b67",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APT.ASX",
            "securityName": "Afterpay Limited",
            "description": "Transfer In - 304 x APT",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 304.000000,
            "price": 118.17000000,
            "transactionValue": 35923.68000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 35923.68
        },
        {
            "transactionKey": "tran_b354d41e7b6948769b95e39fd9436ecc",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BBT.ASX",
            "securityName": "BlueBet Holdings Ltd",
            "description": "Transfer In - 11403 x BBT",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 11403.000000,
            "price": 1.00000000,
            "transactionValue": 11403.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 11403.00
        },
        {
            "transactionKey": "tran_350256b02c874044a373f3bd02b1846b",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BENPH.ASX",
            "securityName": "Bendigo and Adelaide Bank Ltd",
            "description": "Transfer In - 1756 x BENPH",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1756.000000,
            "price": 105.50000000,
            "transactionValue": 185258.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 185258.00
        },
        {
            "transactionKey": "tran_dd195de70ddf4756ad2cdd5e953689a8",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BET.ASX",
            "securityName": "BetMakers Technology Group Limited",
            "description": "Transfer In - 75516 x BET",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 75516.000000,
            "price": 1.07000000,
            "transactionValue": 80802.12000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 80802.12
        },
        {
            "transactionKey": "tran_3939b881cca54d26ae31ddab2157e9ed",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BHP.ASX",
            "securityName": "BHP Group Limited",
            "description": "Transfer In - 757 x BHP",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 757.000000,
            "price": 48.57000000,
            "transactionValue": 36767.49000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 36767.49
        },
        {
            "transactionKey": "tran_499b9874268745f8ae53375f2f8af041",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "BHP.ASX",
            "securityName": "BHP Group Limited",
            "description": "Transfer In - 1415 x BHP",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1415.000000,
            "price": 48.57000000,
            "transactionValue": 68726.55000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 68726.55
        },
        {
            "transactionKey": "tran_384060b7c5644808ab8e183ecce2686f",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "CBA.ASX",
            "securityName": "Commonwealth Bank of Australia",
            "description": "Transfer In - 1527 x CBA",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 1527.000000,
            "price": 99.87000000,
            "transactionValue": 152501.49000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 152501.49
        },
        {
            "transactionKey": "tran_edfcf0ad0129496eb3105d0e4c2c6598",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "CBA.ASX",
            "securityName": "Commonwealth Bank of Australia",
            "description": "Transfer In - 63 x CBA",
            "type": "TransferIn",
            "tradeDate": "2021-06-30T00:00:00",
            "units": 63.000000,
            "price": 99.87000000,
            "transactionValue": 6291.81000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 6291.81
        },
        {
            "transactionKey": "tran_33743b71eb45420b93c61387916f9bc7",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "AQZ.ASX",
            "securityName": "Alliance Aviation Services Limited",
            "description": "Transfer In - 6580 x AQZ",
            "type": "TransferIn",
            "tradeDate": "2022-03-01T00:00:00",
            "units": 6580.000000,
            "price": 4.55000000,
            "transactionValue": 29939.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 29939.00
        },
        {
            "transactionKey": "tran_b1710267b0fc49f885db8313cd0d90a4",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ASB.ASX",
            "securityName": "Austal Ltd.",
            "description": "Transfer In - 10548 x ASB",
            "type": "TransferIn",
            "tradeDate": "2022-03-02T00:00:00",
            "units": 10548.000000,
            "price": 2.05000000,
            "transactionValue": 21623.40000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 21623.40
        },
        {
            "transactionKey": "tran_42a1f88a21c44649bfb3b1d5cdb3fd50",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ABC.ASX",
            "securityName": "Adbri Limited",
            "description": "Buy 1000 ABC.ASX",
            "type": "Buy",
            "tradeDate": "2022-03-03T00:00:00",
            "units": 1000.000000,
            "price": 3.00000000,
            "transactionValue": 3000.00000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 3000.00
        },
        {
            "transactionKey": "tran_6350464f852e474bac2ce6761da666c0",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "APT.ASX",
            "securityName": "Afterpay Limited",
            "description": "Transfer In - 5795 x APT",
            "type": "TransferIn",
            "tradeDate": "2022-03-08T00:00:00",
            "units": 5795.000000,
            "price": 118.17000000,
            "transactionValue": 684795.15000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 684795.15
        },
        {
            "transactionKey": "tran_b3a9211f11d44cef981afd2687008ea9",
            "accountKey": "fa_4a2765c31f6245c9bd514abffdf6b44c",
            "securityCode": "ANZ.ASX",
            "securityName": "Australia & New Zealand Banking Group Ltd.",
            "description": "Transfer In - 192 x ANZ",
            "type": "TransferIn",
            "tradeDate": "2022-03-21T00:00:00",
            "units": 192.000000,
            "price": 28.15000000,
            "transactionValue": 5404.80000000,
            "fees": 0.0,
            "gst": 0.0,
            "netTransactionValue": 5404.80
        }
    ],
    "performance": {
        "resolution": "Monthly",
        "metricType": "Percentage",
        "totalRecords": 14,
        "skip": 0,
        "take": 100,
        "recordsReturned": 14,
        "data": [
            {
                "date": "2021-01-31T00:00:00",
                "metric1": -0.157728,
                "metric2": 0.0
            },
            {
                "date": "2021-02-28T00:00:00",
                "metric1": 0.103755,
                "metric2": 0.0
            },
            {
                "date": "2021-03-31T00:00:00",
                "metric1": 0.076804,
                "metric2": 0.0
            },
            {
                "date": "2021-04-30T00:00:00",
                "metric1": 0.019872,
                "metric2": 0.0
            },
            {
                "date": "2021-05-31T00:00:00",
                "metric1": -0.001045,
                "metric2": 0.0
            },
            {
                "date": "2021-06-30T00:00:00",
                "metric1": -0.012532,
                "metric2": 0.0
            },
            {
                "date": "2021-07-31T00:00:00",
                "metric1": -0.059260,
                "metric2": 0.0
            },
            {
                "date": "2021-08-31T00:00:00",
                "metric1": 0.120523,
                "metric2": 0.0
            },
            {
                "date": "2021-09-30T00:00:00",
                "metric1": -0.048283,
                "metric2": 0.0
            },
            {
                "date": "2021-10-31T00:00:00",
                "metric1": 0.005396,
                "metric2": 0.0
            },
            {
                "date": "2021-11-30T00:00:00",
                "metric1": -0.041500,
                "metric2": 0.0
            },
            {
                "date": "2021-12-31T00:00:00",
                "metric1": -0.040072,
                "metric2": 0.0
            },
            {
                "date": "2022-01-31T00:00:00",
                "metric1": 0.000000,
                "metric2": 0.0
            },
            {
                "date": "2022-02-16T00:00:00",
                "metric1": 0.000000,
                "metric2": 0.0
            }
        ]
    },
    "recentDocuments": {
        "totalRecords": 9,
        "skip": 0,
        "take": 100,
        "recordsReturned": 9,
        "data": [
            {
                "documentKey": "doc_aa205d5b6ed54cd3a4d0ba9f2503786d",
                "name": "Dummy Document 4.pdf",
                "type": "Other",
                "createdOnUtc": "2022-01-25T09:03:34.807",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220334712-e52ec201-14aa-4893-8438-93e69ecf1c1c-Dummy%20Document%204?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=e94bedd34e5a99bd4ce94cbfe2b7d4716f85bdde22bc38b40a54e120264f721b"
            },
            {
                "documentKey": "doc_86272e07139d494c92ff0f878bb577ab",
                "name": "Dummy Document 5.pdf",
                "type": "Other",
                "createdOnUtc": "2022-01-25T09:03:24.133",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220324045-aec5cab8-be84-4e53-ba83-301dfbc0de2b-Dummy%20Document%205?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=799288620158dd805b1eaeeee0df3e96c6a5f82bb808f140cdf8384f34331033"
            },
            {
                "documentKey": "doc_6d339a04c43e403e9fef7cf57baa2bd1",
                "name": "Dummy Document 3.pdf",
                "type": "Other",
                "createdOnUtc": "2022-01-25T09:03:09.48",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220309389-34619f1b-22c3-4166-a473-84bc1bd0e6bf-Dummy%20Document%203?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=e5617caa33842db3edbc2e1f62fdb2406d204f7780d655e19ad07be75b7315e7"
            },
            {
                "documentKey": "doc_9ac942af86394f8f879d877d808fcd96",
                "name": "Dummy Document 2.pdf",
                "type": "Other",
                "createdOnUtc": "2022-01-25T09:02:49.583",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220249473-67d93710-8e2c-4b87-8281-5d6c429b0e08-Dummy%20Document%202?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=c10cef08b8d58f11f299bec097e0fe22a4903a037f8d8e2025f701ea3e35a8bf"
            },
            {
                "documentKey": "doc_2c754b52eb7c4cf9844134f53c38f266",
                "name": "Dummy Document 1.pdf",
                "type": "Other",
                "createdOnUtc": "2022-01-25T09:02:40.413",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220240298-dd8dd2d1-fe9a-4e51-b408-98eca404529a-Dummy%20Document%201?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=56408a6072e95c9b4042da7c08dba13ac320abf1a896054e008ca24040a84560"
            },
            {
                "documentKey": "doc_65b852fd4ba949d9ad40f4924db749db",
                "name": "Dummy Report 5.pdf",
                "type": "Report",
                "createdOnUtc": "2022-01-25T09:02:23.917",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220223670-c87dfae8-e86d-426a-bd0d-122b062658fe-Dummy%20Report%205?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=e9ce3103cdac3b4727e1369700b7ac931d849585984cdf9a8293b30022852ce3"
            },
            {
                "documentKey": "doc_ff903cfeeb7c4f0ab41da3df21fa5a12",
                "name": "Dummy Report 4.pdf",
                "type": "Report",
                "createdOnUtc": "2022-01-25T09:02:12.76",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220212675-a7de8c42-df9e-4d42-980b-11756d0af426-Dummy%20Report%204?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=fa730bf5d72dbb3465adc78ae0d87f4c1bf65d50097d06b229df0c97b46b854c"
            },
            {
                "documentKey": "doc_54a3c1ae20ce42b9a5be5c5d5cf1bf57",
                "name": "Dummy Report 3.pdf",
                "type": "Report",
                "createdOnUtc": "2022-01-25T09:02:00.43",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220200334-34c70dca-b587-4725-8c84-cbf5d604f411-Dummy%20Report%203?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=cdb44c5df5d038219bda81e74f29a66fe6ec1f1b3dc4c95a49ac829d7640fe26"
            },
            {
                "documentKey": "doc_08586bb560cc4685965ca34dff106547",
                "name": "Dummy Report 2.pdf",
                "type": "Report",
                "createdOnUtc": "2022-01-25T09:01:48.417",
                "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20220124/220148313-809145db-9e0f-46c6-87a9-3d49532f0833-Dummy%20Report%202?X-Amz-Expires=300&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIDCHODC2N66PHXGA/20220329/ap-southeast-2/s3/aws4_request&X-Amz-Date=20220329T053851Z&X-Amz-SignedHeaders=host&X-Amz-Signature=0d36ea41919fb818c11fe7a06c666a2593f70787c129a7ba259c42c4c0cda96c"
            }
        ]
    }
};
